import * as React from 'react'
import PropTypes from 'prop-types'

import LocationAutocomplete from '../../../../../ui/Form/components/LocationAutocomplete'
import { LocationFilterShape } from '../../../../../models/LocationFilter'

const LocationFilter = React.memo(({ filterValue, onSetFilter }) => (
  <LocationAutocomplete
    id="frontpage-search-location"
    value={filterValue}
    onChange={locationFilter => onSetFilter(locationFilter)}
    onReset={() => onSetFilter(null)}
  />
))

LocationFilter.propTypes = {
  filterValue: LocationFilterShape,
  onSetFilter: PropTypes.func.isRequired,
}
LocationFilter.defaultProps = {
  filterValue: null,
}

export default LocationFilter
